// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface CassandraResourcesListCassandraRoleAssignmentsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface CassandraResourcesDeleteCassandraRoleAssignmentOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface CassandraResourcesCreateUpdateCassandraRoleAssignmentOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface CassandraResourcesGetCassandraRoleAssignmentOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface CassandraResourcesListCassandraRoleDefinitionsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface CassandraResourcesDeleteCassandraRoleDefinitionOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface CassandraResourcesCreateUpdateCassandraRoleDefinitionOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface CassandraResourcesGetCassandraRoleDefinitionOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface CassandraResourcesListCassandraTablesOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface CassandraResourcesDeleteCassandraTableOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface CassandraResourcesCreateUpdateCassandraTableOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface CassandraResourcesGetCassandraTableOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface CassandraResourcesListCassandraKeyspacesOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface CassandraResourcesDeleteCassandraKeyspaceOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface CassandraResourcesCreateUpdateCassandraKeyspaceOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface CassandraResourcesGetCassandraKeyspaceOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface CassandraResourcesMigrateCassandraTableToManualThroughputOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface CassandraResourcesMigrateCassandraTableToAutoscaleOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface CassandraResourcesUpdateCassandraTableThroughputOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface CassandraResourcesGetCassandraTableThroughputOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface CassandraResourcesMigrateCassandraKeyspaceToManualThroughputOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface CassandraResourcesMigrateCassandraKeyspaceToAutoscaleOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface CassandraResourcesUpdateCassandraKeyspaceThroughputOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface CassandraResourcesGetCassandraKeyspaceThroughputOptionalParams extends OperationOptions {}
